import { computed, getCurrentInstance, ref, watchEffect } from "vue";
import ComponentesService from "@/services/ComponentesService";
import FuncoesHelper from "@/helpers/FuncoesHelper";
import { useRoute } from "vue-router";
import { useStore } from "@/store";
import StatusComponenteConstant from "@/constants/StatusComponenteConstant";
import { onBeforeRouteLeave } from "vue-router";

class ComponenteFotoService {
    setup({ opcoes, respostas, respostaObrigatoria, identificador, etapaComponente, modulo, resumoModulos }) {
        const identificadorRota = ref(FuncoesHelper.obterParametrosRota('identificador'));
        const tiposFotos = ref(opcoes);
        const outrasFotos = ref([]);
        const statusResposta = ref(StatusComponenteConstant.PREENCHIDO.chave);
        const confirmaExcluirFoto = ref(false);
        const fotoExcluir = ref({ id: '', idArquivoChecklistModular: '' });

        if (respostas !== null) {
            Object.entries(respostas).forEach(([key, resposta]) => {
                const tipoCorrespondente = Object.values(tiposFotos.value).find(opcao => 'foto_' + opcao.label === resposta.nome);
                if (tipoCorrespondente) {
                    tipoCorrespondente.imagemUpload = resposta.imagem;
                    tipoCorrespondente.idArquivoChecklistModular = resposta.idArquivoChecklistModular;
                } else if (resposta.nome === 'foto_Outras') {
                    outrasFotos.value.push({
                        id: key,
                        imagem: resposta.imagem,
                        label: resposta.nome.split('_')[1],
                        observacao: resposta.observacao,
                        idArquivoChecklistModular: resposta.idArquivoChecklistModular
                    });
                }
            });
        }

        if (!resumoModulos) {
            Object.entries(tiposFotos.value).forEach(([key, tipo]) => tipo.id = key);

            const respostaAlterada = Object.values(tiposFotos.value).every(tipoFoto => tipoFoto.imagemUpload);
            statusResposta.value = ComponentesService.validaStatusRespostaComponente(respostaObrigatoria, respostaAlterada);
            ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta.value);
        }

        return {
            identificadorRota,
            tiposFotos,
            outrasFotos,
            confirmaExcluirFoto,
            fotoExcluir,
            idComponente: identificador,
            statusResposta
        };
    }

    tirarFotoSetup() {
        const exibirLoader = ref(true);
        const fullscreenState = ref(true);
        const temFoto = ref(false);

        const route = useRoute();
        const store = useStore();
        const etapaAtual = ref(FuncoesHelper.obterParametrosRota('etapa'));
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'));
        const idComponente = ref(FuncoesHelper.obterParametrosRota('idComponente'));
        const modulo = ref(FuncoesHelper.obterParametrosRota('modulo'));
        const localRealizacao = ref(FuncoesHelper.obterParametrosRota('localRealizacao'));

        const moduloAtual = computed(() => store.state.modulos.find(module => module.idChecklistModulo == modulo.value));
        const dadosComponentes = ref(moduloAtual.value.etapas.componentes[etapaAtual.value][idComponente.value]);

        const tipo = ref(route.query.tipo);
        const idImagem = ref(route.query.id);

        store.state.fotosTemp = {};
        watchEffect(() => {
            setTimeout(() => {
                exibirLoader.value = false;
            }, 500);
        }, { immediate: true });

        return {
            etapaAtual,
            identificador,
            idComponente,
            modulo,
            localRealizacao,
            dadosComponentes,
            exibirLoader,
            fullscreenState,
            temFoto,
            tipo,
            idImagem
        }
    }

    detalheFotoSetup() {
        const route = useRoute()
        const store = useStore()
        const etapaAtual = ref(FuncoesHelper.obterParametrosRota('etapa'))
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'))
        const idComponente = ref(FuncoesHelper.obterParametrosRota('idComponente'))
        const modulo = ref(FuncoesHelper.obterParametrosRota('modulo'))
        const localRealizacao = ref(FuncoesHelper.obterParametrosRota('localRealizacao'))

        const moduloAtual = computed(() => store.state.modulos.find(module => module.idChecklistModulo == modulo.value))
        const dadosComponentes = ref(moduloAtual.value.etapas.componentes[etapaAtual.value][idComponente.value])
        const imagem = ref(store.state.fotosTemp.imgUrl);
        const larguraImagem = ref(store.state.fotosTemp.largura);
        const alturaImagem = ref(store.state.fotosTemp.altura);
        const geolocalizacao = ref(store.state.fotosTemp.geolocalizacao);
        const horario = ref(store.state.fotosTemp.horario);

        const tipo = ref(route.query.tipo)
        const idImagem = ref(route.query.id)
        const tipoFoto = ref('')
        const exibirLoader = ref(false)
        const estadoUltimaMarcacao = ref([]);

        const { proxy } = getCurrentInstance();
        const saindoProgramaticamente = ref(false);
        const ignorarConfirmacao = ref(false);

        onBeforeRouteLeave(() => {
            if (ignorarConfirmacao.value) {
                return true;
            }
            if (saindoProgramaticamente.value) {
                return true;
            }
            return new Promise((resolve) => {
                proxy.confirmarSaida()
                    .then(() => {
                        saindoProgramaticamente.value = true;
                        proxy.sairDetalhesFotos()
                        resolve(false);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        });


        return {
            etapaAtual,
            identificador,
            imagem,
            larguraImagem,
            alturaImagem,
            geolocalizacao,
            horario,
            tipo,
            tipoFoto,
            idImagem,
            exibirLoader,
            idComponente,
            dadosComponentes,
            modulo,
            localRealizacao,
            estadoUltimaMarcacao,
            ignorarConfirmacao
        }
    }
}

export default new ComponenteFotoService();